'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('project-board', {
      url: '/project/:id',
      template: '<project-board></project-board>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/project/board/project-board.routes.js